import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Inicio.css";
import Header from "../../componentsIni/Header";
import MobileNav from "../../componentsIni/MobileNav";
import MainContent from "../../componentsIni/MainContent";
import Footer from "../../componentsIni/Footer";
import WhatsAppButton from "../../componentsIni/WhatsAppButton";

export default function Inicio() {
  const [seccion, setSeccion] = useState("inicio");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const [activeTheme, setActiveTheme] = useState("hero");

  // Reset theme when navigating away from inicio
  useEffect(() => {
    if (seccion !== "inicio") setActiveTheme("light");
    else setActiveTheme("hero");
  }, [seccion]);


  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  // Check if user prefers reduced motion
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;



  const handleNavClick = (section) => {
    setMobileMenuOpen(false);
    setSeccion(section);
  };

  // Scroll to top on section change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [seccion]);

  // 1️⃣ Leer el hash de la URL al cargar la página
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setSeccion(hash);
    }
    setInitialized(true);
  }, []);

  // 2️⃣ Actualizar el hash cuando cambie la sección (solo después de inicializar)
  useEffect(() => {
    if (!initialized) return;
    if (seccion) {
      window.location.hash = seccion;
    }
  }, [seccion, initialized]);

  // 3️⃣ Escuchar los cambios de hash (para soportar atrás/adelante)
  useEffect(() => {
    const onHashChange = () => {
      const newHash = window.location.hash.replace("#", "") || "inicio";
      setSeccion(newHash);
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);



  return (
    <div className="inicio-container-ini" data-section-theme={activeTheme}>
      <Header
        toggleMobileMenu={toggleMobileMenu}
        mobileMenuOpen={mobileMenuOpen}
        seccion={seccion}
        handleNavClick={handleNavClick}
      />
      <MobileNav
        mobileMenuOpen={mobileMenuOpen}
        seccion={seccion}
        handleNavClick={handleNavClick}
        onClose={() => setMobileMenuOpen(false)}
      />
      <MainContent seccion={seccion} handleNavClick={handleNavClick} onThemeChange={setActiveTheme} />
      <Footer />
      <WhatsAppButton />

    </div>
  );
}

